import React, { useState, useEffect } from "react";
import { Formik, Form, FormikHelpers, Field } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Appstore/store";
import {
    UpdateFlagKeyword, GetallFlagKeyword
} from "../Features/Flagkeyword";
import { IoMdArrowRoundBack } from "react-icons/io";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";

interface FormValues {
    keyword: string;
}

const UpdateFlagkeyword: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id }: any = useParams();

    const { flagkeyworddata } = useSelector(
        (state: RootState) => state.flagkeyword
    );
    const record: FormValues | any = flagkeyworddata.find(
        (recodID) => recodID.id === Number(id)
    );


    const validationSchema = Yup.object({
        keyword: Yup.string()
            .min(1, "Keyword must be at least 1 characters")
            .max(255, "Keyword must be at most 255 characters")
            .required("Keyword is required")
            .trim(),
    });


    useEffect(() => {
        if (id) {
            dispatch(setIsLoading(true));
            dispatch(GetallFlagKeyword({ search: "", page: 1, limit: 10 }))
                .unwrap()
                .catch((err) => {
                    console.error("Error fetching Flag keyword", err);
                })
                .finally(() => {
                    setTimeout(() => dispatch(setIsLoading(false)), 500);
                });
        }
    }, [id, dispatch]);

    const initialValues: FormValues = {
        keyword: record?.keyword || "",

    };

    const navigatetobackpage = () => {
        navigate(-1);
    };

    return (
        <div>
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card mt-4">
                                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                                    <h2 className="w-100 mb-md-0 fs-3">Update Flag Keyword</h2>
                                    <Link to={""} className="text-decoration-none">
                                        <button
                                            onClick={navigatetobackpage}
                                            className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                        >
                                            <IoMdArrowRoundBack /> Back
                                        </button>
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <Formik
                                        initialValues={initialValues}
                                        enableReinitialize={true}
                                        validationSchema={validationSchema}
                                        onSubmit={async (
                                            values: FormValues,
                                            { setSubmitting }: FormikHelpers<FormValues>
                                        ) => {
                                            const { id }: any = record;
                                            const Data = {
                                                keyword: values.keyword,

                                            };
                                            try {
                                                const response: any = await dispatch(
                                                    UpdateFlagKeyword({
                                                        id: id ?? 0,
                                                        updatedData: Data,
                                                    })
                                                );
                                                if (
                                                    response.payload &&
                                                    response.payload.status === "success"
                                                ) {
                                                    navigate("/admin/flag-keyword");
                                                    toast.success(response.payload.message);
                                                } else {
                                                    toast.error(response.payload.message);
                                                }
                                            } finally {
                                                setSubmitting(false);
                                                dispatch(setIsLoading(false));
                                            }
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            isSubmitting,
                                        }) => (
                                            <Form>
                                                <div className="row">
                                                    <div className="form-group mb-3 col-md-6">
                                                        <label htmlFor="keyword">
                                                            Keyword<span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={`form-control shadow-none ${touched.keyword && errors.keyword ? "is-invalid" : ""
                                                                }`}
                                                            id="keyword"
                                                            name="keyword"
                                                            placeholder="Enter a Keyword"
                                                            value={values.keyword}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {touched.keyword && errors.keyword && (
                                                            <div className="text-danger">{errors.keyword}</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-2">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Save..." : "Save"}
                                                    </button>
                                                    <Link to="/admin/flag-keyword" className="btn btn-secondary">
                                                        Cancel
                                                    </Link>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default UpdateFlagkeyword;

